module.exports = __webpack_public_path__ + "images/emoji/signal_strength.f92a10fb85742850a66a.png";